import { X } from "lucide-react";
import React, { useEffect } from "react";

function ModalLayout({
  children,
  onClose,
  title,
  maxWidth = "max-w-4xl",
  menuRef,
}: {
  children: React.ReactNode;
  onClose: () => void;
  title: string;
  maxWidth?: string;
  menuRef?: React.RefObject<HTMLDivElement | null>;
}) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div
      ref={menuRef}
      onClick={onClose}
      className="fixed inset-0 z-50 overflow-y-auto bg-black/40 backdrop-blur-xs"
      data-lenis-prevent="true"
    >
      <div className="flex min-h-full items-center justify-center p-4 sm:p-6">
        <div
          onClick={(e) => e.stopPropagation()}
          className={`relative w-full ${maxWidth} bg-white rounded-3xl shadow-2xl transform transition-all duration-300 scale-100 opacity-100 animate-modal`}
        >
          <div className="flex items-center justify-between border-b border-gray-200 pb-3 pt-6 px-6">
            <h2 className="text-xl sm:text-2xl font-medium text-blumine-600 line-clamp-1">
              {title}
            </h2>
            <button
              onClick={onClose}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-blumine-600 text-blumine-600 hover:bg-blumine-600/10 hover:rotate-90 transition-all duration-300"
              aria-label="Close"
            >
              <X size={20} />
            </button>
          </div>

          {children}
        </div>
      </div>

      <style>
        {`
          @keyframes modal {
            0% {
              opacity: 0;
              transform: translateY(20px) scale(0.95);
            }
            100% {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }
          .animate-modal {
            animation: modal 0.3s ease-out forwards;
          }
        `}
      </style>
    </div>
  );
}

export default ModalLayout;
